import React, { SyntheticEvent } from 'react';
import Lottie from 'lottie-react';
import CharaPlease from '../../../character/json/chara_please.json';
import MusicAlbumDeletePopupSequence from './MusicAlbumDeletePopupSequence';
import DateTimeUtility from '../../../common/utility/DateTimeUtility';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import MusicAlbumAddPopupSequence from './MusicAlbumAddPopupSequence';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';
import { MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicEntity } from '../../types/MusicEntityTypes';

function MusicAlbumUserInfoNotFilledPopup({
  onClose,
} : {
  onClose: () => void,
}) {
  return (
    <PopupContainer title="音楽配信サービス" onClose={() => { onClose(); }}>
      <Lottie
        animationData={CharaPlease} 
        style={{ width: '180px', margin: '-35px auto' }}
      />
      <p>
        おっと！まだ銀行口座などの情報を伺っていないようです。
        <br />
        先に「ユーザー情報設定」ページに入力をお願いします。
      </p>
      <form>
        <div className="list__body">
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => { onClose(); }}>キャンセル</CustomButton>
              <CustomButton type="default-split" onClick={() => { document.location.href = '/artists/user_info'; }}>ユーザー情報へ</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}

function MusicAlbumHelpMessagePopup({
  onClose,
  children,
} : {
  onClose: () => void,
  children: React.ReactNode,
}) {
  return (
    <PopupContainer title="よくある質問" onClose={() => { onClose(); }}>
      <form>
        <div className="list__body">
          {children}
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel" onClick={() => { onClose(); }}>閉じる</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}

function MusicAlbumHelpMessagePopup1({
  onClose,
} : {
  onClose: () => void,
}) {
  return (
    <MusicAlbumHelpMessagePopup onClose={onClose}>
      <p>Q.申し込み完了後、内容を変更できますか？</p>
      <p>
        A.恐れ入りますが、申込完了後の内容の変更は受け付けることができません。詳しくは
        <a href="https://help.frekul.com/208/">こちら</a>
        をご確認ください。
      </p>
    </MusicAlbumHelpMessagePopup>
  );
}

// 編集可能
function MusicAlbumListEditableItemView({
  musicAlbum,
  statusName,
  onRemove,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity,
    })[],
  },
  statusName: string,
  onRemove: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/control-has-associated-label */ }
      <a href="/" className="cancel" onClick={(e) => { cancelEvent(e); onRemove(); }}><img src="/img/music/bt_cancel_m.svg" alt="" /></a>
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label>{statusName}</label>
      <a href={`/music_albums/edit/${musicAlbum.id}`} className="thumb" style={{ background: `url(${musicAlbum.image_url})` }}>
        <div className="inner">
          <span className="ttl">{musicAlbum.music_album_tracks.length === 1 ? musicAlbum.music_album_tracks[0].music.title : musicAlbum.title}</span>
          <span className="name">{musicAlbum.compound_artist_name}</span>
        </div>
        { /* eslint-disable-next-line max-len */ }
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
        <span className="bt_edit" onClick={(e) => { cancelEvent(e); document.location.href = `/music_albums/edit/${musicAlbum.id}`; }}>編集</span>
      </a>
    </>
  );
}

// 手続き中
function MusicAlbumListProcessingItemView({
  musicAlbum,
  statusName,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity,
    })[],
  },
  statusName: string,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const date = DateTimeUtility.toDate(musicAlbum.publish_process_started_date);
  let fromDate: Date|null = null;
  let toDate: Date|null = null;
  if (date !== null) {
    fromDate = new Date(date.getTime());
    toDate = new Date(date.getTime());
    fromDate.setDate(fromDate.getDate() + 15);
    toDate.setDate(toDate.getDate() + 50);
  }
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label>{statusName}</label>
      <a href={`/music_albums/view/${musicAlbum.id}`} className="thumb" style={{ background: `url(${musicAlbum.image_url})` }}>
        <div className="inner">
          <span className="ttl">{musicAlbum.title}</span>
          <span className="name">{musicAlbum.compound_artist_name}</span>
          <span className="info">
            {fromDate !== null && toDate !== null && (
              `配信開始予定日：${DateTimeUtility.format(fromDate, 'n/j')}〜${DateTimeUtility.format(toDate, 'n/j')}`
            )}
          </span>
        </div>
        { /* eslint-disable-next-line max-len */ }
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
        <span className="bt_edit" onClick={(e) => { cancelEvent(e); document.location.href = `/music_albums/view/${musicAlbum.id}`; }}>詳しく見る</span>
      </a>
    </>
  );
}

// リリース済み
function MusicAlbumListDistributedItemView({
  musicAlbum,
  statusName,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity,
    })[],
  },
  statusName: string,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label>{statusName}</label>
      <a href={`/music_albums/view/${musicAlbum.id}`} className="thumb" style={{ background: `url(${musicAlbum.image_url})` }}>
        {musicAlbum.release_unread && (
          <span className="notice_mark" />
        )}
        <div className="inner">
          <span className="ttl">{musicAlbum.title}</span>
          <span className="name">{musicAlbum.compound_artist_name}</span>
        </div>
        { /* eslint-disable-next-line max-len */ }
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
        <span className="bt_edit" onClick={(e) => { cancelEvent(e); document.location.href = `/music_albums/view/${musicAlbum.id}`; }}>詳しく見る</span>
      </a>
    </>
  );
}

// 配信停止の手続き中
function MusicAlbumListCancellingItemView({
  musicAlbum,
  statusName,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity,
    })[],
  },
  statusName: string,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const date = DateTimeUtility.toDate(musicAlbum.cancellation_process_started_date);
  let fromDate: Date|null = null;
  let toDate: Date|null = null;
  if (date) {
    fromDate = new Date(date.getTime());
    toDate = new Date(date.getTime());
    fromDate.setDate(fromDate.getDate() + 30);
    toDate.setDate(toDate.getDate() + 40);
  }
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label>{statusName}</label>
      <a href={`/music_albums/view/${musicAlbum.id}`} className="thumb" style={{ background: `url(${musicAlbum.image_url})` }}>
        <div className="inner">
          <span className="ttl">{musicAlbum.title}</span>
          <span className="name">{musicAlbum.compound_artist_name}</span>
          {musicAlbum.cancellation_process_started_date && fromDate !== null && toDate !== null && (
            <span className="info">
              {fromDate !== null && toDate !== null && (
                `配信停止予定日：${DateTimeUtility.format(fromDate, 'n/j')}〜${DateTimeUtility.format(toDate, 'n/j')}`
              )}
            </span>
          )}
        </div>
        { /* eslint-disable-next-line max-len */ }
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
        <span className="bt_edit" onClick={(e) => { cancelEvent(e); document.location.href = `/music_albums/view/${musicAlbum.id}`; }}>詳しく見る</span>
      </a>
    </>
  );
}

// リリース済み
function MusicAlbumListRejectedItemView({
  musicAlbum,
  statusName,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity,
    })[],
  },
  statusName: string,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <>
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label>{statusName}</label>
      <a href={`/music_albums/view/${musicAlbum.id}`} className="thumb" style={{ background: `url(${musicAlbum.image_url})` }}>
        <div className="inner">
          <span className="ttl">{musicAlbum.title}</span>
          <span className="name">{musicAlbum.compound_artist_name}</span>
        </div>
        { /* eslint-disable-next-line max-len */ }
        { /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ }
        <span className="bt_edit" onClick={(e) => { cancelEvent(e); document.location.href = `/music_albums/view/${musicAlbum.id}`; }}>詳しく見る</span>
      </a>
    </>
  );
}

export default function MusicAlbumListView({
  cancelReasonOptions,
  hasMusic,
  userInfoFilled
} : {
  userInfoFilled: boolean,
  hasMusic: boolean,
  cancelReasonOptions: {
    text: string,
    value: string,
  }[],
}) {
  const [musicAlbums, setMusicAlbums] = React.useState<(MusicAlbumEntity & { music_album_tracks: (MusicAlbumTrackEntity & { music: MusicEntity })[] })[]>([]);
  const [selectedMusicAlbum, setSelectedMusicAlbum] = React.useState<(MusicAlbumEntity & { music_album_tracks: (MusicAlbumTrackEntity & { music: MusicEntity })[] })|null>(null);
  const [popup, setPopup] = React.useState<'help1'|'help2'|'help3'|'help4'|'add'|'userInfoNotFilled'|'delete'|null>(null);
  const { getMusicAlbums } = React.useContext(MusicDistributionClientContext);

  const musicAlbums1 = musicAlbums.filter((musicAlbum) => musicAlbum.release_status === 0);
  const musicAlbums2 = musicAlbums.filter((musicAlbum) => 
    musicAlbum.release_status === 1 || musicAlbum.release_status === 7 ||
    musicAlbum.release_status === 8 || musicAlbum.release_status === 9);
  // eslint-disable-next-line max-len
  const musicAlbums3 = musicAlbums.filter((musicAlbum) => musicAlbum.release_status === 2);
  const musicAlbums4 = musicAlbums.filter((musicAlbum) => musicAlbum.release_status === 4);
  const musicAlbums5 = musicAlbums.filter((musicAlbum) => musicAlbum.release_status === 5);
  const musicAlbums6 = musicAlbums.filter((musicAlbum) => musicAlbum.release_status === 3);
  const musicAlbums7 = musicAlbums.filter((musicAlbum) => musicAlbum.release_status === 6);

  const reloadMusicAlbums = () => {
    getMusicAlbums().then((data) => {
      setMusicAlbums(data.musicAlbums);
    });
  };

  React.useEffect(() => {
    reloadMusicAlbums();
  }, []);

  return (
    <>
      <CustomButton
        type="add"
        onClick={() => setPopup(userInfoFilled ? 'add' : 'userInfoNotFilled')}
      >
        配信をする
        <span>(新規作成)</span>
      </CustomButton>
      {musicAlbums5.length > 0 && (
        <div className="list_box edit">
          <p style={{ display: 'none' }}>ここにテキスト説明ここにテキスト説明</p>
          <div className="scroll_x">
            <ul>
              {musicAlbums5.map((musicAlbum) => (
                <li key={musicAlbum.id}>
                  <MusicAlbumListEditableItemView
                    musicAlbum={musicAlbum}
                    statusName='要修正'
                    onRemove={() => { setSelectedMusicAlbum(musicAlbum); setPopup('delete'); }}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      {musicAlbums1.length > 0 && (
        <div className="list_box edit">
          <p style={{ display: 'none' }}>ここにテキスト説明ここにテキスト説明</p>
          <div className="scroll_x">
            <ul>
              {musicAlbums1.map((musicAlbum) => (
                <li key={musicAlbum.id}>
                  <MusicAlbumListEditableItemView
                    musicAlbum={musicAlbum}
                    statusName="作成中"
                    onRemove={() => { setSelectedMusicAlbum(musicAlbum); setPopup('delete'); }} 
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <div style={{ fontWeight: 'bold', marginTop: '20px', marginBottom: '15px' }}>
        よくある質問
      </div>
      <div style={{ marginLeft: '10px' }}>
        <CustomButton type="secondary-modal" onClick={() => setPopup('help1')}>Q.申し込み完了後、内容を変更できますか？</CustomButton>
        <br />
        <CustomButton type="secondary-modal" onClick={() => setPopup('help2')}>Q.配信先で表示されるアーティスト写真は変更できますか？</CustomButton>
        <br />
        <CustomButton type="secondary-modal" onClick={() => setPopup('help3')}>Q.一部の配信先でまだ配信されていません</CustomButton>
        <br />
        <CustomButton type="secondary-modal" onClick={() => setPopup('help4')}>Q.配信先で同名のアーティストと混同されている</CustomButton>
        <br />
        <a href="https://help.frekul.com/?s=%E9%9F%B3%E6%A5%BD%E9%85%8D%E4%BF%A1%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9">音楽配信サービスに関するヘルプ一覧</a>
      </div>
      {musicAlbums2.length > 0 && (
        <div className="list_box process">
          <p style={{ display: 'none' }}>ここにテキスト説明ここにテキスト説明</p>
          <div className="scroll_x">
            <ul>
              {musicAlbums2.map((musicAlbum) => (
                <li key={musicAlbum.id}>
                  <MusicAlbumListProcessingItemView
                    statusName="手続き中"
                    musicAlbum={musicAlbum}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      {musicAlbums3.length > 0 && (
        <div className="list_box delivery">
          <p style={{ display: 'none' }}>ここにテキスト説明ここにテキスト説明</p>
          <div className="scroll_x">
            <ul>
              {musicAlbums3.map((musicAlbum) => (
                <li key={musicAlbum.id}>
                  <MusicAlbumListDistributedItemView
                    statusName="配信中"
                    musicAlbum={musicAlbum}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      {musicAlbums6.length > 0 && (
        <div className="list_box stop">
          <p style={{ display: 'none' }}>ここにテキスト説明ここにテキスト説明</p>
          <div className="scroll_x">
            <ul>
              {musicAlbums6.map((musicAlbum) => (
                <li key={musicAlbum.id}>
                  <MusicAlbumListCancellingItemView
                    statusName="配信停止の手続き中"
                    musicAlbum={musicAlbum}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      {musicAlbums4.length > 0 && (
        <div className="list_box stop">
          <p style={{ display: 'none' }}>ここにテキスト説明ここにテキスト説明</p>
          <div className="scroll_x">
            <ul>
              {musicAlbums4.map((musicAlbum) => (
                <li key={musicAlbum.id}>
                  <MusicAlbumListDistributedItemView
                    statusName="配信停止"
                    musicAlbum={musicAlbum}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      {musicAlbums7.length > 0 && (
        <div className="list_box stop">
          <p style={{ display: 'none' }}>ここにテキスト説明ここにテキスト説明</p>
          <div className="scroll_x">
            <ul>
              {musicAlbums7.map((musicAlbum) => (
                <li key={musicAlbum.id}>
                  <MusicAlbumListRejectedItemView
                    statusName="配信不可"
                    musicAlbum={musicAlbum}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
      {popup === 'delete' && selectedMusicAlbum !== null && (
        <MusicAlbumDeletePopupSequence
          musicAlbum={selectedMusicAlbum}
          cancelReasonOptions={cancelReasonOptions}
          onCancel={() => { setPopup(null); setSelectedMusicAlbum(null); }}
          //onDone={() => { setPopup(null); setSelectedMusicAlbum(null); reloadMusicAlbums(); }}
        />
      )}
      {popup === 'add' && (
        <MusicAlbumAddPopupSequence
          hasMusic={hasMusic}
          onClose={() => { setPopup(null); }}
          onGoToMusicAlbumCreate={() => { document.location.href = '/music_albums/add'; }}
          onGoToMusicUpload={() => { document.location.href = '/musics'; }}
        />
      )}
      {popup === 'userInfoNotFilled' && (
        <MusicAlbumUserInfoNotFilledPopup
          onClose={() => { setPopup(null); }}
        />
      )}
      {popup === 'help1' && (
        <MusicAlbumHelpMessagePopup onClose={() => { setPopup(null); }}>
          <p>Q.申し込み完了後、内容を変更できますか？</p>
          <p>
            A.恐れ入りますが、申込完了後の内容の変更は受け付けることができません。詳しくは
            <a href="https://help.frekul.com/208/" target="_blank" rel="noreferrer">こちら</a>
            をご確認ください。
          </p>
        </MusicAlbumHelpMessagePopup>
      )}
      {popup === 'help2' && (
        <MusicAlbumHelpMessagePopup onClose={() => { setPopup(null); }}>
          <p>Q.配信先で表示されるアーティスト写真は変更できますか？</p>
          <p>
            A.恐れ入りますが、アーティスト写真の変更には対応しておりません。詳しくは
            <a href="https://help.frekul.com/909/" target="_blank" rel="noreferrer">こちら</a>
            をご確認ください。
          </p>
        </MusicAlbumHelpMessagePopup>
      )}
      {popup === 'help3' && (
        <MusicAlbumHelpMessagePopup onClose={() => { setPopup(null); }}>
          <p>Q.一部の配信先でまだ配信されていません。</p>
          <p>
            A.配信先によって開始タイミングが違う場合がございます。時間をおいてお試しください。詳しくは
            <a href="https://help.frekul.com/194/" target="_blank" rel="noreferrer">こちら</a>
            をご確認ください。
          </p>
        </MusicAlbumHelpMessagePopup>
      )}
      {popup === 'help4' && (
        <MusicAlbumHelpMessagePopup onClose={() => { setPopup(null); }}>
          <p>Q.配信先で同名のアーティストと混同されている</p>
          <p>
            A.大変申し訳ございません。修正させていただきますので、お手数ですが
            <a href="https://help.frekul.com/210/" target="_blank" rel="noreferrer">こちら</a>
            をご確認いただき修正内容の入力をお願いします。
          </p>
        </MusicAlbumHelpMessagePopup>
      )}
    </>
  );
}
